import angular, { IHttpService } from 'angular'

/**
 * Resource for the balances API
 */
angular
  .module('webregister.factories')
  .factory('BalancesResource', BalancesResourceFactory)

export type BalancesResource = ReturnType<typeof BalancesResourceFactory>

function BalancesResourceFactory($http: IHttpService) {
  const BALANCES_ENDPOINT = '/api/2.0/balances'

  /**
   * Get the gift card entity for the specified transaction ID
   *
   * @method getGiftCardByTransactionID
   * @param  transactionID {String}
   *         The gift card number
   *
   * @return {Promise} The $http request promise
   */
  function getGiftCardByTransactionID(transactionID: string) {
    return $http
      .get(`${BALANCES_ENDPOINT}/gift_cards/transactions/${transactionID}`)
      .then(response => response.data)
  }

  /**
   * Get the retailer gift card settings
   *
   * @method getRetailerGiftCardSettings
   *
   * @return {Promise} The $http request promise
   */
  function getRetailerGiftCardSettings() {
    return $http
      .get(`${BALANCES_ENDPOINT}/gift_cards/retailer/status`)
      .then(response => response.data)
  }

  return {
    getGiftCardByTransactionID,
    getRetailerGiftCardSettings,
  }
}
